/**
 * Lookup-таблица метаданных нарративов для web.
 *
 * Источник правды — `NARRATIVE_ASPECTS` в `@pflow/shared/v2` (как
 * массив). Здесь — Map по `id` для O(1) lookup'а из компонентов.
 */

import { NARRATIVE_ASPECTS, type NarrativeAspectMeta, type NarrativeAspectId } from '@pflow/shared/v2';

export const NARRATIVE_ASPECT_META: ReadonlyMap<NarrativeAspectId, NarrativeAspectMeta> =
    new Map(NARRATIVE_ASPECTS.map(m => [m.id, m] as const));
